// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"74966020","307":"a0ff3f6f","436":"27187674","463":"e793962c","531":"26d72eaa","593":"b9b68e31","951":"1bca46eb"}[chunkId] + ".chunk.css";
};